const Main = () => import(/* webpackChunkName: "module-channel" */ '@/views/channel/recovery/main/index.vue');
const App = () => import(/* webpackChunkName: "module-channel" */ '@/views/channel/recovery/app/index.vue');
const Sem_pc = () => import(/* webpackChunkName: "module-sem" */ '@/views/sem/sem_pc.vue');
const Sem_H5 = () => import(/* webpackChunkName: "module-sem" */ '@/views/sem/sem_h5.vue');
const Sem_Succ = () => import(/* webpackChunkName: "module-sem" */ '@/views/sem/sem_success.vue');
const ActivityExpiration = () => import(/* webpackChunkName: "module-channel" */ '@/views/channel/activity-expiration.vue');
const shareWX = () => import(/* webpackChunkName: "module-channel" */ '@/views/channel/shareWX.vue');
const Sem_APP = () => import(/* webpackChunkName: "module-sem" */ '@/views/sem/sem_app.vue');

export default [
  {
    path: '/channel/wdfs',
    name: 'Main',
    component: Main,
    meta:{
      title:'万店复苏计划',
    }
  },
  {
    path: '/channel/wdfs/branch',
    name: 'Branch',
    // component: Branch,
    // 活动结束换页面展示
    component: ActivityExpiration,
    meta:{
      title:'上上参谋分会场',
    }
  },
  {
    path: '/channel/wdfs/app',
    name: 'App',
    component: App,
    meta: { id: 10221 }
  },
  {
    path: '/sem_pc',
    name: 'sem_pc',
    component: Sem_pc
  },
  {
    path: '/sem_h5',
    name: 'sem_h5',
    component: Sem_H5,
    meta: { id: 10631 }
  },
  {
    path: '/sem_success',
    name: 'sem_success',
    component: Sem_Succ
  },
  {
    path: '/sem_app',
    name: 'sem_app',
    component: Sem_APP
  },
  {
    path: '/shareWX',
    name: 'shareWX',
    component: shareWX
  },
  {
    path: '/channel/activity-expiration',
    name: 'activityExpiration',
    component: ActivityExpiration,
    meta: {
      title: '活动已结束',
    }
  },

];
